import { z } from "zod";

const boolish = z
  .union([z.literal("true"), z.literal("false"), z.literal("")])
  .default("false")
  .transform((v) => v === "true");

// Variante com default LIGADO (só desliga com "false" explícito) — p/ serviços ativos por padrão.
const boolishOn = z
  .union([z.literal("true"), z.literal("false"), z.literal("")])
  .default("true")
  .transform((v) => v !== "false");

const envSchema = z.object({
  // Empty string = relative paths (Vite proxy in dev). Full URL for production.
  VITE_API_BASE_URL: z.string().default(""),
  // Base do site público (imobgo-public) p/ montar links de vitrine por shareCode.
  // Apex sem o /public (o prefixo é adicionado em lib/public-url). (hub#307)
  VITE_PUBLIC_SITE_URL: z.string().default("https://imobgo.app"),
  VITE_AUTH_REALM: z.string().default("agent"),

  VITE_MOCK_AUTH: boolish,
  VITE_MOCK_DASHBOARD: boolish,
  VITE_MOCK_PROPERTIES: boolish,
  VITE_MOCK_LEADS: boolish,
  VITE_MOCK_PIPELINE: boolish,
  VITE_MOCK_PROPOSALS: boolish,
  VITE_MOCK_DEALS: boolish,
  VITE_MOCK_DEMANDS: boolish,
  VITE_MOCK_AGENDA: boolish,
  VITE_MOCK_CONTRACTS: boolish,
  VITE_MOCK_INSPECTIONS: boolish,
  VITE_MOCK_COBROKING: boolish,
  VITE_MOCK_LISTINGS: boolish,
  VITE_MOCK_COMMISSIONS: boolish,
  VITE_MOCK_WALLET: boolish,
  VITE_MOCK_FINANCIAL: boolish,
  VITE_MOCK_AUTOMATION: boolish,
  VITE_MOCK_REPORTS: boolish,
  VITE_MOCK_SETTINGS: boolish,
  VITE_MOCK_NOTIFICATIONS: boolish,
  VITE_MOCK_GOALS: boolish,
  VITE_MOCK_SUBSCRIPTION: boolish,
  VITE_MOCK_LAUNCHES: boolish,
  VITE_MOCK_REFERRALS: boolish,
  VITE_MOCK_ONBOARDING: boolish,
  VITE_MOCK_SUPPORT: boolish,
  VITE_MOCK_PARTNERS: boolish,
  VITE_MOCK_SHOWCASES: boolish,

  VITE_GOOGLE_CLIENT_ID: z.string().default(""),
  VITE_MICROSOFT_CLIENT_ID: z.string().default(""),
  VITE_MICROSOFT_AUTHORITY: z.string().default("https://login.microsoftonline.com/common"),
  VITE_APPLE_CLIENT_ID: z.string().default(""),
  VITE_APPLE_REDIRECT_URI: z.string().default(""),

  // Cloudflare Turnstile (anti-abuso de auth — hub#345). Ativo por padrão; desligar com
  // VITE_TURNSTILE_ENABLED=false. A site key é PÚBLICA (vai no HTML); default é a do ImobGo,
  // sobrescrevível por ambiente.
  VITE_TURNSTILE_ENABLED: boolishOn,
  VITE_TURNSTILE_SITE_KEY: z.string().default("0x4AAAAAADiIDaq92_tIKV1t"),

  VITE_SENTRY_DSN: z.string().default(""),
  VITE_SENTRY_ENVIRONMENT: z.string().default(""),
  VITE_SENTRY_RELEASE: z.string().default(""),
  VITE_FEATURE_WALLET: boolish,
  VITE_FEATURE_AUTOMATION: boolish,
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error("[env] invalid environment:", parsed.error.flatten().fieldErrors);
  throw new Error("Variáveis de ambiente inválidas. Veja o console.");
}

export const env = parsed.data;
export type Env = typeof env;
